import { cva as t, css as e } from "@/styled-system/css";
const n = t({
  // TODO: use animation tokens when available
  base: {
    animation: "spin 0.5s linear infinite",
    stroke: "currentColor"
  },
  variants: {
    onImpact: {
      false: {
        color: "text.accent.brand.hero-fixed"
      },
      true: {
        color: "text.onImpact.neutral"
      }
    }
  }
}), o = e.raw({
  width: "100%",
  height: "100%",
  backgroundImage: "conic-gradient(from 90deg at 50% 66%, transparent 20deg, currentColor 360deg)"
});
export {
  o as spinnerFillStyle,
  n as spinnerStyles
};
//# sourceMappingURL=spinner.styles.js.map
